module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0027.e5d3cdf3.jpg";